// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"71950606","424":"87a86790","703":"591402e0","723":"a32b2990","729":"bb5007dd","745":"809ee202","850":"e7d24fef"}[chunkId] + ".chunk.js";
};